var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.574 223.359C165.388 184.763 186.788 170.975 195.386 168.905C228.305 161.423 242.854 196.055 246.29 215.442C246.436 216.267 246.497 217.093 246.497 217.93V370.349C246.497 372.019 246.259 373.681 245.639 375.232C241.78 384.878 231.399 400.572 213.186 406.101C208.397 407.554 204.016 410.333 201.016 414.339C190.778 428.014 171.08 445.031 148.574 436.877C123.099 429.234 85.0445 380.417 136.633 246.287",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.533 251.064C182.011 264.12 190.323 289.85 219.747 288.322",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.07 284.501C170.38 291.853 175.783 306.342 194.908 305.481",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M380.722 223.359C363.908 184.763 342.508 170.975 333.91 168.905C300.991 161.423 286.443 196.055 283.006 215.442C282.86 216.267 282.799 217.093 282.799 217.93V370.349C282.799 372.019 283.037 373.681 283.657 375.232C287.516 384.878 297.897 400.572 316.11 406.101C320.899 407.554 325.281 410.333 328.28 414.339C338.518 428.014 358.216 445.031 380.722 436.877C406.197 429.234 444.252 380.417 392.663 246.287",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M347.763 251.064C347.285 264.12 338.974 289.85 309.549 288.322",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M359.227 284.501C358.916 291.853 353.514 306.342 334.388 305.481",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M248.407 192.311V92H286.143V192.311C285.761 215.239 312.415 235.938 325.79 243.421L303.339 268.738C266.654 220.589 239.013 248.675 229.778 268.738L211.149 243.421C242.484 219.347 249.044 199.316 248.407 192.311Z",
    fill: "#F9F9F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M248.407 92V192.311C249.044 199.316 242.484 219.347 211.149 243.421",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M284.751 92V192.311C284.114 199.316 290.674 219.347 322.01 243.421",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M233.122 265.784C243.631 245.881 269.52 220.692 300.473 265.784",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.893 324.625C152.393 324.625 154.42 326.215 154.42 328.177L154.42 332.912C154.42 334.874 152.393 336.464 149.893 336.464C147.392 336.464 145.366 334.874 145.366 332.912L145.366 328.177C145.366 326.215 147.392 324.625 149.893 324.625Z",
    fill: "#1C1B1F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.893 360.84C152.393 360.84 154.42 362.617 154.42 364.81L154.42 370.103C154.42 372.295 152.393 374.073 149.893 374.073C147.392 374.073 145.366 372.295 145.366 370.103L145.366 364.81C145.366 362.617 147.392 360.84 149.893 360.84Z",
    fill: "#1C1B1F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.235 331.54C168.758 333.063 168.758 335.532 167.235 337.055L163.559 340.731C162.036 342.254 159.567 342.254 158.044 340.731C156.521 339.209 156.521 336.739 158.044 335.217L161.72 331.54C163.243 330.017 165.712 330.017 167.235 331.54Z",
    fill: "#1C1B1F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.132 357.643C142.655 359.166 142.655 361.635 141.132 363.158L137.455 366.835C135.933 368.358 133.463 368.358 131.941 366.835C130.418 365.312 130.418 362.843 131.941 361.32L135.617 357.643C137.14 356.121 139.609 356.121 141.132 357.643Z",
    fill: "#1C1B1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.084 331.54C133.607 330.017 136.076 330.017 137.599 331.54L141.275 335.216C142.798 336.739 142.798 339.208 141.275 340.731C139.752 342.254 137.283 342.254 135.761 340.731L132.084 337.055C130.561 335.532 130.561 333.063 132.084 331.54Z",
    fill: "#1C1B1F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.187 357.643C159.71 356.12 162.179 356.12 163.702 357.643L167.378 361.32C168.901 362.842 168.901 365.311 167.378 366.834C165.856 368.357 163.386 368.357 161.864 366.834L158.187 363.158C156.664 361.635 156.664 359.166 158.187 357.643Z",
    fill: "#1C1B1F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.169 348.652C125.169 346.537 126.759 344.822 128.721 344.822L133.456 344.822C135.418 344.822 137.008 346.537 137.008 348.652C137.008 350.768 135.418 352.483 133.456 352.483L128.721 352.483C126.759 352.483 125.169 350.768 125.169 348.652Z",
    fill: "#1C1B1F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.384 348.652C161.384 346.537 163.161 344.822 165.354 344.822L170.647 344.822C172.839 344.822 174.616 346.537 174.616 348.652C174.616 350.768 172.839 352.483 170.647 352.483L165.354 352.483C163.161 352.483 161.384 350.768 161.384 348.652Z",
    fill: "#1C1B1F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 349C165.563 357.847 158.391 365.019 149.544 365.019C140.698 365.019 133.526 357.847 133.526 349C133.526 340.154 140.698 332.982 149.544 332.982C158.391 332.982 165.563 340.154 165.563 349Z",
    fill: "#F9F9F9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M155.812 348.652C155.812 352.306 152.85 355.268 149.196 355.268C145.542 355.268 142.58 352.306 142.58 348.652C142.58 344.998 145.542 342.036 149.196 342.036C152.85 342.036 155.812 344.998 155.812 348.652Z",
    fill: "#1C1B1F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.486 365.704C374.986 365.704 377.013 367.295 377.013 369.256L377.013 373.992C377.013 375.954 374.986 377.544 372.486 377.544C369.986 377.544 367.959 375.954 367.959 373.992L367.959 369.256C367.959 367.295 369.986 365.704 372.486 365.704Z",
    fill: "#1C1B1F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.486 401.92C374.986 401.92 377.013 403.697 377.013 405.889L377.013 411.182C377.013 413.375 374.986 415.152 372.486 415.152C369.986 415.152 367.959 413.375 367.959 411.182L367.959 405.889C367.959 403.697 369.986 401.92 372.486 401.92Z",
    fill: "#1C1B1F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.829 372.62C391.352 374.143 391.352 376.612 389.829 378.134L386.152 381.811C384.63 383.334 382.16 383.334 380.638 381.811C379.115 380.288 379.115 377.819 380.638 376.296L384.314 372.62C385.837 371.097 388.306 371.097 389.829 372.62Z",
    fill: "#1C1B1F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.725 398.723C365.248 400.246 365.248 402.715 363.725 404.238L360.049 407.914C358.526 409.437 356.057 409.437 354.534 407.914C353.011 406.391 353.011 403.922 354.534 402.399L358.211 398.723C359.733 397.2 362.203 397.2 363.725 398.723Z",
    fill: "#1C1B1F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.678 372.619C356.201 371.096 358.67 371.096 360.193 372.619L363.869 376.296C365.392 377.819 365.392 380.288 363.869 381.811C362.346 383.333 359.877 383.333 358.354 381.811L354.678 378.134C353.155 376.611 353.155 374.142 354.678 372.619Z",
    fill: "#1C1B1F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.781 398.723C382.303 397.2 384.773 397.2 386.295 398.723L389.972 402.399C391.495 403.922 391.495 406.391 389.972 407.914C388.449 409.437 385.98 409.437 384.457 407.914L380.781 404.237C379.258 402.715 379.258 400.245 380.781 398.723Z",
    fill: "#1C1B1F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.762 389.732C347.762 387.616 349.353 385.901 351.314 385.901L356.05 385.901C358.012 385.901 359.602 387.616 359.602 389.732C359.602 391.847 358.012 393.562 356.05 393.562L351.314 393.562C349.353 393.562 347.762 391.847 347.762 389.732Z",
    fill: "#1C1B1F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.978 389.732C383.978 387.616 385.755 385.901 387.947 385.901L393.24 385.901C395.433 385.901 397.21 387.616 397.21 389.732C397.21 391.847 395.433 393.562 393.24 393.562L387.947 393.562C385.755 393.562 383.978 391.847 383.978 389.732Z",
    fill: "#1C1B1F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M388.156 390.08C388.156 398.927 380.985 406.098 372.138 406.098C363.291 406.098 356.12 398.927 356.12 390.08C356.12 381.233 363.291 374.062 372.138 374.062C380.985 374.062 388.156 381.233 388.156 390.08Z",
    fill: "#F9F9F9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M378.406 389.732C378.406 393.386 375.444 396.348 371.79 396.348C368.136 396.348 365.174 393.386 365.174 389.732C365.174 386.078 368.136 383.115 371.79 383.115C375.444 383.115 378.406 386.078 378.406 389.732Z",
    fill: "#1C1B1F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.918 334.178C321.353 334.178 322.516 335.091 322.516 336.217L322.516 338.935C322.516 340.061 321.353 340.974 319.918 340.974C318.483 340.974 317.32 340.061 317.32 338.935L317.32 336.217C317.32 335.091 318.483 334.178 319.918 334.178Z",
    fill: "#1C1B1F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.918 354.965C321.353 354.965 322.516 355.985 322.516 357.243L322.516 360.281C322.516 361.539 321.353 362.56 319.918 362.56C318.483 362.56 317.32 361.539 317.32 360.281L317.32 357.243C317.32 355.985 318.483 354.965 319.918 354.965Z",
    fill: "#1C1B1F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.872 338.147C330.746 339.021 330.746 340.439 329.872 341.313L327.762 343.423C326.888 344.297 325.471 344.297 324.597 343.423C323.723 342.549 323.723 341.132 324.597 340.258L326.707 338.147C327.581 337.273 328.998 337.273 329.872 338.147Z",
    fill: "#1C1B1F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.89 353.13C315.764 354.004 315.764 355.421 314.89 356.295L312.78 358.405C311.906 359.279 310.488 359.279 309.614 358.405C308.74 357.531 308.74 356.114 309.614 355.24L311.724 353.13C312.599 352.255 314.016 352.255 314.89 353.13Z",
    fill: "#1C1B1F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.697 338.147C310.571 337.273 311.988 337.273 312.862 338.147L314.972 340.257C315.846 341.131 315.846 342.549 314.972 343.423C314.098 344.297 312.681 344.297 311.807 343.423L309.697 341.312C308.823 340.438 308.823 339.021 309.697 338.147Z",
    fill: "#1C1B1F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.679 353.13C325.553 352.255 326.97 352.255 327.844 353.13L329.954 355.24C330.828 356.114 330.828 357.531 329.954 358.405C329.08 359.279 327.663 359.279 326.789 358.405L324.679 356.295C323.805 355.421 323.805 354.004 324.679 353.13Z",
    fill: "#1C1B1F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.728 347.969C305.728 346.755 306.64 345.77 307.766 345.77L310.484 345.77C311.61 345.77 312.523 346.755 312.523 347.969C312.523 349.183 311.61 350.167 310.484 350.167L307.766 350.167C306.64 350.167 305.728 349.183 305.728 347.969Z",
    fill: "#1C1B1F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.514 347.969C326.514 346.755 327.534 345.77 328.792 345.77L331.83 345.77C333.089 345.77 334.109 346.755 334.109 347.969C334.109 349.183 333.089 350.167 331.83 350.167L328.792 350.167C327.534 350.167 326.514 349.183 326.514 347.969Z",
    fill: "#1C1B1F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M328.912 348.169C328.912 353.247 324.796 357.363 319.718 357.363C314.64 357.363 310.524 353.247 310.524 348.169C310.524 343.091 314.64 338.975 319.718 338.975C324.796 338.975 328.912 343.091 328.912 348.169Z",
    fill: "#F9F9F9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M323.316 347.969C323.316 350.066 321.615 351.767 319.518 351.767C317.421 351.767 315.721 350.066 315.721 347.969C315.721 345.872 317.421 344.172 319.518 344.172C321.615 344.172 323.316 345.872 323.316 347.969Z",
    fill: "#1C1B1F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.831 351.374C216.266 351.374 217.429 352.287 217.429 353.413L217.429 356.131C217.429 357.257 216.266 358.17 214.831 358.17C213.396 358.17 212.233 357.257 212.233 356.131L212.233 353.413C212.233 352.287 213.396 351.374 214.831 351.374Z",
    fill: "#1C1B1F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.831 372.161C216.266 372.161 217.429 373.181 217.429 374.439L217.429 377.477C217.429 378.735 216.266 379.756 214.831 379.756C213.396 379.756 212.233 378.735 212.233 377.477L212.233 374.439C212.233 373.181 213.396 372.161 214.831 372.161Z",
    fill: "#1C1B1F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.785 355.343C225.659 356.217 225.659 357.635 224.785 358.509L222.675 360.619C221.801 361.493 220.384 361.493 219.51 360.619C218.635 359.745 218.635 358.328 219.51 357.454L221.62 355.343C222.494 354.469 223.911 354.469 224.785 355.343Z",
    fill: "#1C1B1F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.803 370.326C210.677 371.2 210.677 372.617 209.803 373.491L207.692 375.601C206.818 376.475 205.401 376.475 204.527 375.601C203.653 374.727 203.653 373.31 204.527 372.436L206.637 370.326C207.511 369.451 208.929 369.451 209.803 370.326Z",
    fill: "#1C1B1F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.61 355.343C205.484 354.469 206.901 354.469 207.775 355.343L209.885 357.453C210.759 358.327 210.759 359.745 209.885 360.619C209.011 361.493 207.594 361.493 206.72 360.619L204.61 358.508C203.736 357.634 203.736 356.217 204.61 355.343Z",
    fill: "#1C1B1F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.592 370.326C220.466 369.451 221.883 369.451 222.757 370.326L224.867 372.436C225.741 373.31 225.741 374.727 224.867 375.601C223.993 376.475 222.576 376.475 221.702 375.601L219.592 373.491C218.718 372.617 218.718 371.2 219.592 370.326Z",
    fill: "#1C1B1F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.64 365.165C200.64 363.951 201.553 362.967 202.679 362.967L205.397 362.967C206.523 362.967 207.436 363.951 207.436 365.165C207.436 366.379 206.523 367.364 205.397 367.364L202.679 367.364C201.553 367.364 200.64 366.379 200.64 365.165Z",
    fill: "#1C1B1F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.427 365.165C221.427 363.951 222.447 362.967 223.705 362.967L226.743 362.967C228.001 362.967 229.021 363.951 229.021 365.165C229.021 366.379 228.001 367.364 226.743 367.364L223.705 367.364C222.447 367.364 221.427 366.379 221.427 365.165Z",
    fill: "#1C1B1F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M223.825 365.365C223.825 370.443 219.709 374.559 214.631 374.559C209.553 374.559 205.437 370.443 205.437 365.365C205.437 360.287 209.553 356.171 214.631 356.171C219.709 356.171 223.825 360.287 223.825 365.365Z",
    fill: "#F9F9F9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M218.229 365.165C218.229 367.262 216.528 368.963 214.431 368.963C212.334 368.963 210.634 367.262 210.634 365.165C210.634 363.068 212.334 361.368 214.431 361.368C216.528 361.368 218.229 363.068 218.229 365.165Z",
    fill: "#1C1B1F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.198 387.754C165.919 387.754 167.314 388.849 167.314 390.199L167.314 393.459C167.314 394.809 165.919 395.904 164.198 395.904C162.477 395.904 161.082 394.809 161.082 393.459L161.082 390.199C161.082 388.849 162.477 387.754 164.198 387.754Z",
    fill: "#1C1B1F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.198 412.682C165.919 412.682 167.314 413.906 167.314 415.415L167.314 419.058C167.314 420.567 165.919 421.791 164.198 421.791C162.477 421.791 161.082 420.567 161.082 419.058L161.082 415.415C161.082 413.906 162.477 412.682 164.198 412.682Z",
    fill: "#1C1B1F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.136 392.514C177.184 393.562 177.184 395.262 176.136 396.31L173.605 398.841C172.557 399.889 170.857 399.889 169.809 398.841C168.761 397.793 168.761 396.093 169.809 395.045L172.34 392.514C173.388 391.466 175.087 391.466 176.136 392.514Z",
    fill: "#1C1B1F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.168 410.481C159.216 411.53 159.216 413.229 158.168 414.277L155.637 416.808C154.589 417.856 152.89 417.856 151.841 416.808C150.793 415.76 150.793 414.06 151.841 413.012L154.372 410.481C155.42 409.433 157.12 409.433 158.168 410.481Z",
    fill: "#1C1B1F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.94 392.514C152.988 391.466 154.688 391.466 155.736 392.514L158.267 395.045C159.315 396.093 159.315 397.792 158.267 398.841C157.218 399.889 155.519 399.889 154.471 398.841L151.94 396.31C150.892 395.262 150.892 393.562 151.94 392.514Z",
    fill: "#1C1B1F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.908 410.482C170.956 409.433 172.655 409.433 173.704 410.482L176.234 413.012C177.282 414.061 177.282 415.76 176.234 416.808C175.186 417.857 173.486 417.857 172.438 416.808L169.908 414.278C168.859 413.229 168.859 411.53 169.908 410.482Z",
    fill: "#1C1B1F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.18 404.293C147.18 402.837 148.275 401.656 149.625 401.656L152.885 401.656C154.235 401.656 155.33 402.837 155.33 404.293C155.33 405.749 154.235 406.929 152.885 406.929L149.625 406.929C148.275 406.929 147.18 405.749 147.18 404.293Z",
    fill: "#1C1B1F"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.108 404.293C172.108 402.837 173.331 401.656 174.84 401.656L178.484 401.656C179.993 401.656 181.216 402.837 181.216 404.293C181.216 405.749 179.993 406.929 178.484 406.929L174.84 406.929C173.331 406.929 172.108 405.749 172.108 404.293Z",
    fill: "#1C1B1F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M174.984 404.532C174.984 410.622 170.048 415.558 163.958 415.558C157.869 415.558 152.932 410.622 152.932 404.532C152.932 398.443 157.869 393.507 163.958 393.507C170.048 393.507 174.984 398.443 174.984 404.532Z",
    fill: "#F9F9F9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M168.273 404.293C168.273 406.808 166.234 408.847 163.718 408.847C161.203 408.847 159.164 406.808 159.164 404.293C159.164 401.777 161.203 399.739 163.718 399.739C166.234 399.739 168.273 401.777 168.273 404.293Z",
    fill: "#1C1B1F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 384.543,
    cy: 341.343,
    r: 10.0311,
    fill: "#1C1B1F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.044,
    cy: 384.333,
    r: 7.16504,
    fill: "#1C1B1F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.767,
    cy: 384.811,
    r: 4.77669,
    fill: "#1C1B1F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.475,
    cy: 388.155,
    r: 7.16504,
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/내과_폐렴.071c8db59b859e12648174f32554aa3a.svg";
export { ForwardRef as ReactComponent };